import backgroundBet from "../assets/audio/background/background_bet.mp3";
import backgroundDraw from "../assets/audio/background/background_draw.mp3";
import buttonDelete from "../assets/audio/effect/effect_button_delete.mp3";
import buttonDraw from "../assets/audio/effect/effect_button_draw.mp3";
import buttonModalOk from "../assets/audio/effect/effect_button_modal_ok.mp3";
import buttonMultiplier from "../assets/audio/effect/effect_button_multiplier.mp3";
import buttonPlay from "../assets/audio/effect/effect_button_play.mp3";
import buttonUndo from "../assets/audio/effect/effect_button_undo.mp3";
import carousel from "../assets/audio/effect/effect_carousel.mp3";
import countdown from "../assets/audio/effect/effect_countdown.mp3";
import fullStake from "../assets/audio/effect/effect_full_stake.mp3";
import betLost from "../assets/audio/effect/effect_loss.mp3";
import modalInfo from "../assets/audio/effect/effect_modal_info.mp3";
import rouletteTick from "../assets/audio/effect/effect_roulette_tick.mp3";
import betWon from "../assets/audio/effect/effect_win.mp3";

import { AudioEnum } from "../enums";

export const getFooterButtonAudio = (styleClass: string): number => {
  if (styleClass.includes("play")) {
    return AudioEnum.EFFECT_PLAY;
  }
  if (styleClass.includes("delete")) {
    return AudioEnum.EFFECT_DELETE;
  }

  return AudioEnum.EFFECT_DRAW;
};

export const getAudio = (audioToBePlayed: number): string => {
  switch (audioToBePlayed) {
    case AudioEnum.BACKGROUND_BET:
      return backgroundBet;
    case AudioEnum.BACKGROUND_DRAW:
      return backgroundDraw;
    case AudioEnum.EFFECT_DELETE:
      return buttonDelete;
    case AudioEnum.EFFECT_DRAW:
      return buttonDraw;
    case AudioEnum.EFFECT_MODAL_OK:
      return buttonModalOk;
    case AudioEnum.EFFECT_MULTIPLIER:
      return buttonMultiplier;
    case AudioEnum.EFFECT_PLAY:
      return buttonPlay;
    case AudioEnum.EFFECT_UNDO:
      return buttonUndo;
    case AudioEnum.EFFECT_CAROUSEL:
      return carousel;
    case AudioEnum.EFFECT_COUNTDOWN:
      return countdown;
    case AudioEnum.EFFECT_FULL_STAKE:
      return fullStake;
    case AudioEnum.EFFECT_BET_LOST:
      return betLost;
    case AudioEnum.EFFECT_MODAL_INFO:
      return modalInfo;
    case AudioEnum.EFFECT_ROULETTE_TICK:
      return rouletteTick;
    default:
      return betWon;
  }
};

export const checkToggleAudio = (
  isBackgroundAudioEnabled: boolean,
  areAudioEffectsEnabled: boolean
): boolean => {
  if (!isBackgroundAudioEnabled && !areAudioEffectsEnabled) {
    return false;
  }

  return true;
};
